//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { _MiscMessages, ConfigSystemParams, eSimApiPaths } from 'src/app/core/consts';
import { AuditDTO } from 'src/app/core/models/system/audit/audit.dto';
import { AuthenticationService } from '../../../auth.service';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { ConfigSystemService } from '../config-system/config-system-service';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';

@Injectable({ providedIn: 'root' })

export class AuditService {

  get auditErrors() { return this.configSystemService?.getValueAsBoolean(ConfigSystemParams.SureSimAuditFrontendErrors, true) ?? false; }

  private curUser: SystemUserDTO;
  
  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private encryptionService    : EncryptionService,
    private httpClientService    : HttpClientService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }
  
  public logError(error: string) {
    try {
      if (!this.auditErrors)
        return;

      const audit: AuditDTO={
        additionalInfo: error,
        fromFrontend  : true,
        isError       : true,
        message       : _MiscMessages.FrontendError,
        userID        : this.curUser.userId,
      }

      this.post(audit)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.formatHttpError(error)));
        })
      )
      .subscribe({
        next: data => {

        },
        error: error => {
          if (environment.outputErrorsToConsole)
            console.log(`Audit log error: ${error}`);
        }
      });
    }
    catch(e) {
      if (environment.outputErrorsToConsole)
        console.log(`Audit log exception: ${(<Error>e)?.message ?? e}`);
    }
  }

  public post(audit: AuditDTO): Observable<AuditDTO> {
    try {
      //JSON.stringify(audit)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(audit), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Audit, 
                                                              { objectEncSS: objectEncSS });
                         })
                  );
    }
    catch(e) {
      if (environment.outputErrorsToConsole)
        console.log(`Audit post exception: ${(<Error>e)?.message ?? e}`);
      
      return of();
    }
  }

  private formatHttpError(error: any): string {
    if (typeof error==='string')
      return error;

    if (typeof error?.message==='string')
      return error.message;

    try {
      return JSON.stringify(error);
    }
    catch {
      return `${error}`;
    }
  }
}
